import * as React from "react"
import Layout from "../components/layout"
import MainBlock from "../components/blocks/main";
import Sitemap from "../components/blocks/sitemap";
import coverImage from "../images/headers/header_qliksense.webp"
import data from "../data/pages/nl.qlik-sense";
import ImageAndText from "../components/blocks/image-text";
import ImageAndTextScaling from "../components/blocks/image-text-scaling";
import TextAndText from "../components/blocks/text-text";
import TextAndText2headers from "../components/blocks/text-text-2headers";
import Contact from "../components/blocks/contact-block";
import VideoAndText from "../components/blocks/video-text";
import EmbeddedVideoAndText from "../components/blocks/embedded-video-text";

import Helmet from "../components/helmet";

// markup
const QlikSensePage = () => {

    return (
        <Layout>
            <Helmet meta={data.pageData.meta} />
            <MainBlock id={"mainCover"} cover={coverImage} type={"sub"} jumbotron={data.pageData.jumbotron} bpx={40} bpy={60}>
            </MainBlock>
            <ImageAndTextScaling block={data.pageData.intro} textSide={"left"} backgroundColor={'very-dark-greyish-blue'} textColor={'white-text'} >
                <div className={'t-24 bold'}>
                    {data.pageData.intro.custom}
                </div>
                <span className={'bold t-24'}>Meer weten?</span> <a href={'#contact'} className={'white-button mt-40'}>Contact</a>
            </ImageAndTextScaling>
            <TextAndText block={data.pageData.innovatief} backgroundColor={'white'} textColor={'deep-blue-text'}>
                <div>
                    <iframe title={'Demo NodeGraph'} width="560" height="315" src="https://www.youtube-nocookie.com/embed/RB-O4nAMTAI"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen/>
                </div>
            </TextAndText>
            <ImageAndTextScaling block={data.pageData.engine} textSide={"right"} backgroundColor={'pure-white'} textColor={'deep-blue-text'} circle={true} />
            <ImageAndText block={data.pageData.enterprise} textSide={"left"} backgroundColor={'blue'} textColor={'white-text'} circle={true} />
            <TextAndText block={data.pageData.nprinting} backgroundColor={'white'} textColor={'deep-blue-text'} circle={true} />
            <EmbeddedVideoAndText textSide={"right"} backgroundColor={'blue'} textColor={'white-text'} circle={true} block={data.pageData.datatransfer} video={
                <iframe width="560" height="315" src="https://www.youtube.com/embed/El9nPUYrdWM"
                        title="YouTube video player" frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen/>}>
            </EmbeddedVideoAndText>
            {/*<ImageAndText block={data.pageData.datatransfer} textSide={"right"} backgroundColor={'blue'} textColor={'white-text'} circle={true} />*/}
            <TextAndText2headers block={data.pageData.connectors} backgroundColor={'white'} textColor={'deep-blue-text'}/>
            <ImageAndTextScaling block={data.pageData.qlikview} textSide={"right"} backgroundColor={'blue'} textColor={'white-text'} circle={true} />
            <VideoAndText padding={'p-20'} controls={true} block={data.pageData.klanten} textSide={"left"} backgroundColor={'white'} textColor={'deep-blue-text'} />
            {/*<TextAndText block={data.pageData.klanten} backgroundColor={'white'} textColor={'deep-blue-text'} circle={true} />*/}
            <Contact block={data.pageData.contactList} page={data.pageData.jumbotron.title} backgroundColor={'blue-1'} textColor={'white-text'} />
            <Sitemap/>
        </Layout>
    )
}

export default QlikSensePage;
